import React from "react";

export default function MeetingTimeButton(props) {
  return (
    <button
      className={`px-4 py-2 rounded-full border-[1.5px] border-[var(--brand)] text-sm md:text-base font-semibold transition-all ${
        props.nowState === props.time
          ? "bg-[var(--brand)] text-white shadow-[0_4px_14px_rgba(108,99,255,.3)]"
          : "bg-white text-[var(--brand)] hover:bg-[var(--brand)] hover:text-white"
      }`}
      onClick={props.onClick}
    >
      {props.time}
    </button>
  );
}
